/**
 * @fileoverview Reads the payload out of a `{ success, data }` response body.
 */

/**
 * Returns `raw.data` when `raw` is an object with a `data` field, else `raw`
 * itself. ApiService already unwraps the envelope, so this only guards callers
 * against a body that arrives still wrapped.
 */
export function unwrapData<T>(raw: unknown): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as { data: unknown }).data as T;
  }
  return raw as T;
}
